module.exports = __webpack_public_path__ + "static/media/browser1.1b0f3151.svg";